export default __webpack_public_path__ + "static/profile-img02-7b1bfc2faa8a6ecddd76707b1d5a8ac2.png";